export function isPlural(n: number | undefined | null): boolean {
   return n != 1;
}